import { Maybe } from '@monetize/types/common';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export type RecordShareStateNonNull = {
  [K in keyof RecordShareState]-?: string;
};

interface RecordShareState {
  tenantId?: Maybe<string>;
  recordId?: Maybe<string>;
  token?: Maybe<string>;
}

export const recordShareState = atomWithReset<RecordShareState | null>(null);

// Warning - only use this in children of AnonymousRecordShareWithCodeVerifierLayout where it is guaranteed to be initialized
export const recordShareSelector = atom(
  (get) => get(recordShareState) as RecordShareStateNonNull,
);
